module.exports = __webpack_public_path__ + "static/media/property_sample_1.c1deab20.png";